var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 30,
    viewBox: "0 0 42 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.154 0H3.67651C1.6452 0 0 1.65541 0 3.67651V25.7356C0 27.7687 1.65729 29.4121 3.67651 29.4121H38.154C40.1684 29.4121 41.8306 27.7757 41.8306 25.7356V3.67651C41.8306 1.65901 40.1919 0 38.154 0ZM37.6392 2.45101C36.888 3.19816 23.9613 16.0568 23.515 16.5008C22.8205 17.1952 21.8973 17.5776 20.9153 17.5776C19.9332 17.5776 19.01 17.1951 18.3133 16.4985C18.0131 16.1999 5.22906 3.48321 4.19139 2.45101H37.6392ZM2.45101 25.2367V4.17693L13.0425 14.7126L2.45101 25.2367ZM4.19294 26.9611L14.7802 16.4411L16.5825 18.2339C17.7398 19.3912 19.2786 20.0286 20.9153 20.0286C22.552 20.0286 24.0907 19.3912 25.2458 18.2362L27.0503 16.4411L37.6376 26.9611H4.19294ZM39.3795 25.2367L28.7881 14.7126L39.3795 4.17693V25.2367Z",
    fill: "#1996A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.63235538d2625e536b248075f871c9ff.svg";
export { ForwardRef as ReactComponent };